import React from "react";
import { render } from "react-dom";
import InfiniteCalendar, { Calendar, withRange, withMultipleDates, defaultMultipleDateInterpolation } from "react-infinite-calendar";

let campForm = document.querySelector(".camp-form");
let campEventType = document.querySelector("#camp_event_type");
let initialHiddenFieldValues = document.querySelector("#session_dates__");
let initialSelectedDates;

if (initialHiddenFieldValues?.dataset?.selected){ 
  initialSelectedDates = JSON.parse(initialHiddenFieldValues.dataset.selected);
} else {
  initialSelectedDates = [new Date()];
} 

if (campEventType) {
  campEventType.addEventListener('change', (event) => {
    if (campForm && campEventType.value == 'sessions') {
      render(
        <InfiniteCalendar
          Component={withMultipleDates(Calendar)}
          selected={[
            ...initialSelectedDates
          ]}
          interpolateSelection={defaultMultipleDateInterpolation}
          ref={(pageComponent) => {window.pageComponent = pageComponent}}
          onSelect={function(dateSelection) {

            let startDateField = document.getElementById("camp_start_date");
            let endDateField = document.getElementById("camp_end_date");
            let sessionDatesField = document.getElementById("session_dates__");
            let selectedDatesArr = [...window.pageComponent.state.selected];
            if (selectedDatesArr.includes(dateSelection)){
              selectedDatesArr = selectedDatesArr.filter(item => item != dateSelection)
            } else {
              selectedDatesArr.push(new Date(dateSelection));
            }
            selectedDatesArr = selectedDatesArr.sort((a,b)=> Number(a)-Number(b))
            let startDate = selectedDatesArr[0];
            let endDate = selectedDatesArr.at(-1);
            let allSessionDates = [...new Set(selectedDatesArr)]

            if (allSessionDates.length < 1) {
              let calValidation = document.getElementById(
                "calendar-validation-message"
              );
              calValidation.innerHTML = "";
              calValidation.classList.remove("valid");
              calValidation.classList.add("invalid");
              calValidation.innerHTML =
                '<i class="fa fa-times-circle"></i> To save your event successfully set an end date below - for a one day camp, double click your desired date.';
            }

            if (allSessionDates.length > 1) {
              let calValidation = document.getElementById(
                "calendar-validation-message"
              );
              calValidation.innerHTML = "";
              calValidation.classList.remove("valid");
              sessionDatesField.value = allSessionDates;

              if (startDate <= endDate) {
                startDateField.value = startDate;
                endDateField.value = endDate;
                sessionDatesField.value = allSessionDates;
                calValidation.classList.add("valid");
                calValidation.innerHTML =
                  '<i class="fa fa-check-circle"></i> Success!';
              } else {
                calValidation.classList.add("invalid");
                calValidation.innerHTML =
                  '<i class="fa fa-times-circle"></i> To save your event successfully set a date below.';
              }
            }
          }}
          />,
        calendar
      );
    } else {
      render(
        <InfiniteCalendar
          displayOptions={{
            showTodayHelper: true,
            showOverlay: true
          }}
          Component={withRange(Calendar)}
          height={250}
          minDate={new Date()}
          selected={{
            start: document.getElementById("camp_start_date").value || new Date(),
            end: document.getElementById("camp_end_date").value || new Date()
          }}
          onSelect={function(dateSelection) {
            let startDateField = document.getElementById("camp_start_date");
            let endDateField = document.getElementById("camp_end_date");
            if (dateSelection.eventType == 1) {
              let calValidation = document.getElementById(
                "calendar-validation-message"
              );
              calValidation.innerHTML = "";
              calValidation.classList.remove("valid");
              calValidation.classList.add("invalid");
              calValidation.innerHTML =
                '<i class="fa fa-times-circle"></i> To save your event successfully set an end date below - for a one day camp, double click your desired date.';
            }
            if (dateSelection.eventType == 3) {
              let calValidation = document.getElementById(
                "calendar-validation-message"
              );
              calValidation.innerHTML = "";
              calValidation.classList.remove("valid");
              if (dateSelection.start <= dateSelection.end) {
                startDateField.value = dateSelection.start;
                endDateField.value = dateSelection.end;
                calValidation.classList.add("valid");
                calValidation.innerHTML =
                  '<i class="fa fa-check-circle"></i> Success!';
              } else {
                calValidation.classList.add("invalid");
                calValidation.innerHTML =
                  '<i class="fa fa-times-circle"></i> To save your event successfully set a date below.';
              }
            }
          }}
        />,
        calendar
      );
    }
  });

  if (campForm && campEventType.value == 'sessions') {
    render(
      <InfiniteCalendar
        Component={withMultipleDates(Calendar)}
        selected={[
          ...initialSelectedDates
        ]}
        interpolateSelection={defaultMultipleDateInterpolation}
        ref={(pageComponent) => {window.pageComponent = pageComponent}}
        onSelect={function(dateSelection) {
          let startDateField = document.getElementById("camp_start_date");
          let endDateField = document.getElementById("camp_end_date");
          let sessionDatesField = document.getElementById("session_dates__");
          let selectedDatesArr = [...window.pageComponent.state.selected];
          if (selectedDatesArr.includes(dateSelection)){
            selectedDatesArr = selectedDatesArr.filter(item => item != dateSelection)
          } else {
            selectedDatesArr.push(new Date(dateSelection));
          }
          selectedDatesArr = selectedDatesArr.sort((a,b)=> Number(a)-Number(b))
          let startDate = selectedDatesArr[0];
          let endDate = selectedDatesArr.at(-1);
          let allSessionDates = [...new Set(selectedDatesArr)]
          if (allSessionDates.length < 1) {
            let calValidation = document.getElementById(
              "calendar-validation-message"
            );
            calValidation.innerHTML = "";
            calValidation.classList.remove("valid");
            calValidation.classList.add("invalid");
            calValidation.innerHTML =
              '<i class="fa fa-times-circle"></i> To save your event successfully set an end date below - for a one day camp, double click your desired date.';
          }

          if (allSessionDates.length > 1) {
            let calValidation = document.getElementById(
              "calendar-validation-message"
            );
            calValidation.innerHTML = "";
            calValidation.classList.remove("valid");
            sessionDatesField.value = allSessionDates;
            if (startDate <= endDate) {
              startDateField.value = startDate;
              endDateField.value = endDate;
              sessionDatesField.value = allSessionDates;
              calValidation.classList.add("valid");
              calValidation.innerHTML =
                '<i class="fa fa-check-circle"></i> Success!';
            } else {
              calValidation.classList.add("invalid");
              calValidation.innerHTML =
                '<i class="fa fa-times-circle"></i> To save your event successfully set a date below.';
            }
          }
        }}
        />,
      calendar
    );
  } else {
    render(
      <InfiniteCalendar
        displayOptions={{
          showTodayHelper: true,
          showOverlay: true
        }}
        Component={withRange(Calendar)}
        height={250}
        minDate={new Date()}
        selected={{
          start: document.getElementById("camp_start_date").value || new Date(),
          end: document.getElementById("camp_end_date").value || new Date()
        }}
        onSelect={function(dateSelection) {
          let startDateField = document.getElementById("camp_start_date");
          let endDateField = document.getElementById("camp_end_date");
          if (dateSelection.eventType == 1) {
            let calValidation = document.getElementById(
              "calendar-validation-message"
            );
            calValidation.innerHTML = "";
            calValidation.classList.remove("valid");
            calValidation.classList.add("invalid");
            calValidation.innerHTML =
              '<i class="fa fa-times-circle"></i> To save your event successfully set an end date below - for a one day camp, double click your desired date.';
          }
          if (dateSelection.eventType == 3) {
            let calValidation = document.getElementById(
              "calendar-validation-message"
            );
            calValidation.innerHTML = "";
            calValidation.classList.remove("valid");
            if (dateSelection.start <= dateSelection.end) {
              startDateField.value = dateSelection.start;
              endDateField.value = dateSelection.end;
              calValidation.classList.add("valid");
              calValidation.innerHTML =
                '<i class="fa fa-check-circle"></i> Success!';
            } else {
              calValidation.classList.add("invalid");
              calValidation.innerHTML =
                '<i class="fa fa-times-circle"></i> To save your event successfully set a date below.';
            }
          }
        }}
      />,
      calendar
    );
  }
}

